import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "blocked-24-px_aae3904596c508f3f02f2287b99d0bb5",
  "use": "blocked-24-px_aae3904596c508f3f02f2287b99d0bb5-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"blocked-24-px_aae3904596c508f3f02f2287b99d0bb5\">\n    <path fill-rule=\"evenodd\" d=\"M7.808 17.606a7 7 0 0 0 9.799-9.799l-9.8 9.8zm-1.414-1.414l9.798-9.798a7 7 0 0 0-9.799 9.799zM12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol